import { render, staticRenderFns } from "./AmendForm.vue?vue&type=template&id=854d1ba2"
import script from "./AmendForm.vue?vue&type=script&lang=js"
export * from "./AmendForm.vue?vue&type=script&lang=js"
import style0 from "./AmendForm.vue?vue&type=style&index=0&id=854d1ba2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports